import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as LogoSistema } from '../../assets/images/Logo_CDIEMS_SIGLA.svg';
import { ContextoUsuario } from '../../contextos/usuario/ProvedorUsuario';
import { LoginStore } from '../../stores/LoginStore';
import { Botao } from '../Botao';
import { Icone } from '../Icone';
import {
  Conteiner,
  ConteinerPerfis,
  AreaUsuario,
  ConteinerUsuario,
  NomeUsuario,
  Perfil,
  Opcao,
  ConteinerPerfil,
} from './styles';

export function MenuSuperior() {
  const historico = useHistory();

  const { usuario, sair, atualizarPerfil } = useContext(ContextoUsuario);

  const deslogar = () => {
    sair();
    historico.push('/login');
  };

  const mudarPerfil = async (profile) => {
    await LoginStore.alterarPerfil(profile).then((response) => {
      if (response.status === 200) {
        atualizarPerfil(response.data);
        toast.success('Perfil alterado com sucesso!');
      } else toast.error(response.statusText);
    });
  };

  return (
    <Conteiner>
      <LogoSistema />
      <AreaUsuario>
        <ConteinerUsuario>
          <NomeUsuario>{usuario.nomeUsuario.split(' ')[0]}</NomeUsuario>
          <Perfil href='#'>{usuario.perfil}</Perfil>
          <ConteinerPerfis>
            <ConteinerPerfil>
              {usuario.perfis &&
                usuario.perfis.length > 0 &&
                usuario.perfis.map((item) => (
                  <Opcao key={item} onMouseDown={() => mudarPerfil(item)}>
                    {item}
                  </Opcao>
                ))}
            </ConteinerPerfil>
          </ConteinerPerfis>
        </ConteinerUsuario>
        <Botao cor='danger' aoClicar={deslogar} id='deslogar'>
          <Icone nome='FaPowerOff' tamanho={12} />
        </Botao>
      </AreaUsuario>
    </Conteiner>
  );
}
